import React from 'react';
import { CatalogTable, CatalogTableRow } from '@backstage/plugin-catalog';
import { TableColumn } from '@backstage/core-components';

// Display-only: wrap the stock name column's render so the entity name
// renders lowercase in the catalog table, without touching the underlying
// entity name (routing/lookups still use the real, unmodified casing).
const createLowercaseNameColumn = (): TableColumn<CatalogTableRow> => {
  const base = CatalogTable.columns.createNameColumn();
  return {
    ...base,
    render: row =>
      React.createElement(
        'span',
        { className: 'devhub-lowercase-name' },
        base.render ? base.render(row) : null,
      ),
  };
};

// FOCUS catalog fields — written by create-project-pipeline.yml as plain
// annotations (see Product Development Strategy deck, "one catalog, four
// dimensions"). Blank for any entity the pipeline hasn't touched yet.
const createAnnotationColumn = (
  title: string,
  annotationKey: string,
): TableColumn<CatalogTableRow> => ({
  title,
  field: `entity.metadata.annotations['${annotationKey}']`,
  render: ({ entity }) => entity.metadata.annotations?.[annotationKey] ?? '',
});

// Passed to <CatalogIndexPage columns={...} />, which forwards it straight
// to CatalogTable — CatalogIndexPage does not render children, only props.
export const focusCatalogColumns: TableColumn<CatalogTableRow>[] = [
  createLowercaseNameColumn(),
  createAnnotationColumn('Category', 'ascentt.ai/category'),
  createAnnotationColumn('Lifecycle State', 'ascentt.ai/lifecycle-state'),
  CatalogTable.columns.createOwnerColumn(),
  createAnnotationColumn('Domain Tags', 'ascentt.ai/domain-tags'),
];
